export const hints: Record<string, string> = {
  min: 'อย่างน้อย 8 ตัวอักษร',
  lowercase: 'ตัวพิมพ์เล็ก (a-z)',
  uppercase: 'ตัวพิมพ์ใหญ่ (A-Z)',
  digits: 'ตัวเลข (0-9)',
  symbols: 'อักขระพิเศษ',
}
